/* eslint-disable */
import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import passportActions from 'actions/passport/actions'
import notifactionActions from 'actions/notifications/actions'
import promoActions from 'actions/promocodes/actions'

import PassportPaymentForm from './form'
import { getQueryString } from 'utils/queryString'
import { useHistory } from 'react-router-dom'

const PassportPayment = ({
  plan,
  place,
  planDetails,
  fetchPassportPlanDetails,
  payPassportSubscription,
  user,
  subscription,
  notifyError,
  notification: { type },
  clientApplyCode,
  fetchPassportPaymentDetail,
}) => {
  const history = useHistory()
  const invitationId = getQueryString(history.location.search).invitation_id
  useEffect(() => {
    fetchPassportPaymentDetail({ plan, place, invitation_id: invitationId })
    fetchPassportPlanDetails({ plan, place })
  }, [])

  const { status: subscriptionStatus } = subscription

  useEffect(() => {
    if (subscriptionStatus === 'active') {
      notifyError({ message: 'You already have an existing Passport Subscription.' })
      return <Redirect to="/client/passport" />
    }
  }, [subscriptionStatus])
  const handleInactiveSubscription = useCallback(() => {
    notifyError({ message: 'You already have an existing Passport Subscription.' })
    return <Redirect to="/client/passport" />
  }, [])

  return (
    <div className="passport-payment-form">
      {type === 'success' && <Redirect to="/client/passport" />}
      {subscriptionStatus === 'active' && handleInactiveSubscription()}
      <PassportPaymentForm
        onSubmit={(values) =>
          payPassportSubscription({ ...values, ...planDetails, user, plan, place, invitationId })
        }
        planDetails={planDetails}
        form="public-passport-payment-checkout"
        clientApplyCode={clientApplyCode}
        invitationId={invitationId}
        plan={plan}
        place={place}
      />
    </div>
  )
}

PassportPayment.propTypes = {
  plan: PropTypes.string,
  place: PropTypes.string,
  fetchPassportPlanDetails: PropTypes.func.isRequired,
  payPassportSubscription: PropTypes.func.isRequired,
  planDetails: PropTypes.object,
  user: PropTypes.object.isRequired,
  subscription: PropTypes.object,
  notification: PropTypes.object.isRequired,
  notifyError: PropTypes.func,
  clientApplyCode: PropTypes.func,
  invitation_id: PropTypes.string,
  fetchPassportPaymentDetail: PropTypes.func,
}

const mapStateToProps = ({ passport, auth, notification }) => ({
  planDetails: passport.planDetails,
  user: auth.user,
  subscription: auth.user.subscription || {},
  notification,
})

const mapDispatchToProps = {
  fetchPassportPlanDetails: passportActions.fetchPassportPlanDetails,
  fetchPassportPaymentDetail: passportActions.fetchPassportPaymentDetail,
  payPassportSubscription: passportActions.payPassportSubscription,
  notifyError: notifactionActions.error,
  clientApplyCode: promoActions.clientApplyCode,
}

export default connect(mapStateToProps, mapDispatchToProps)(PassportPayment)
